/** Retired rate-approval lists must not keep producing cards from saved runs. */
export function isUnsupportedInterestRateFinding(value) {
  const text = JSON.stringify(value || '').toLowerCase().replace(/[_-]/g, ' ');
  const interestRate = /interest rates?|savings rates?|\bfd rates?|\bfcnr\b|\bnre\b|\brate claims?|\d+(?:\.\d+)?\s*%/.test(text);
  const approvalClaim = /unapproved|not approved|approved (?:interest )?rates?|approved list|rate.{0,50}(?:approval|compliance)|(?:approval|compliance).{0,50}rate/.test(text);
  if (!interestRate || !approvalClaim) return false;
  // Google's actual policy verdict is still evidence. A historical whitelist
  // mentioned alongside it is not, so list-based cards remain excluded.
  const retiredList = /approved list|approved (?:interest )?rates?/.test(text);
  const providerDisapproval = /google(?: ads)?.{0,60}disapprov|disapprov.{0,60}google(?: ads)?|policy.{0,30}disapproved/.test(text);
  return retiredList || !providerDisapproval;
}
